import axios from 'axios';
import moment from 'moment';
import { getFromToDates } from '../components/Common/cleanDates';

import {
  REQUEST_PO_PDF,
  FETCH_PO_PDF_SUCCESS,
  REQUEST_SI_PDF,
  FETCH_SI_PDF_SUCCESS,
  FETCH_SI_PDF_FAILURE,
  REQUEST_SI_RETURN_PDF,
  FETCH_SI_RETURN_PDF_SUCCESS,
  FETCH_SI_RETURN_PDF_FAILURE,
  REQUEST_WR_PDF,
  FETCH_WR_PDF_SUCCESS,
  REQUEST_AR_PDF,
  FETCH_AR_PDF_SUCCESS,
  REQUEST_AP_PDF,
  FETCH_AP_PDF_SUCCESS,
  REQUEST_PURCHASE_RETURN_PDF,
  FETCH_PURCHASE_RETURN_PDF_SUCCESS,
  REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL,
  REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL_SUCCESS,
  REQUEST_PURCHASE_REFERENCE_PDF,
  FETCH_PURCHASE_REFERENCE_PDF_SUCCESS,
  REQUEST_ROUTING_PDF_SUCCESS,
  REQUEST_ROUTING_PDF_FAILURE,
  REQUEST_ROUTING_PDF,
  REQUEST_DISPATCH_PICKING_LIST_PDF_SUCCESS,
  REQUEST_DISPATCH_PICKING_LIST_PDF_FAILURE,
  REQUEST_DISPATCH_PICKING_LIST_PDF,
  REQUEST_DISPATCH_PACKING_LIST_PDF_SUCCESS,
  REQUEST_DISPATCH_PACKING_LIST_PDF_FAILURE,
  REQUEST_DISPATCH_PACKING_LIST_PDF,
  REQUEST_DISPATCH_SALES_INVOICE_PDF_SUCCESS,
  REQUEST_DISPATCH_SALES_INVOICE_PDF_FAILURE,
  REQUEST_DISPATCH_SALES_INVOICE_PDF,
  REQUEST_PO_NOSUBTOTAL_PDF,
  REQUEST_PO_NOSUBTOTAL_PDF_SUCCESS,
  REQUEST_SI_NOSUBTOTAL_PDF,
  REQUEST_SI_NOSUBTOTAL_PDF_SUCCESS,
  REQUEST_SI_RETURN_NOSUBTOTAL_PDF,
  REQUEST_SI_RETURN_NOSUBTOTAL_PDF_SUCCESS,
} from './type';

import {
  PURCHASE_ORDER_PRINT_URL,
  SALES_INVOICE_PRINT_URL,
  SALES_INVOICE_RETURN_PRINT_URL,
  WAREHOUSE_RECEIVE_PRINT_URL,
  AR_PRINT_URL,
  AR_PRINT_PLAIN_URL,
  AP_PRINT_URL,
  PURCHASE_RETURNS_URL,
  PURCHASE_URL,
  DISPATCH_URL,
  PURCHASE_ORDER_PRINT_NOSUBTOTAL_URL,
  SALES_INVOICE_PRINT_NOSUBTOTAL_URL,
  SALES_INVOICE_RETURN_PRINT_NOSUBTOTAL_URL,
  PURCHASE_RETURNS_NO_SUBTOTALS,
  RECEIVE_URL,
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';


export function printPurchaseOrder(purchaseOrderID) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PO_PDF });
    return axios.get(
      `${PURCHASE_ORDER_PRINT_URL}print/${purchaseOrderID}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchPurchaseOrderPDFSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

function fetchPurchaseOrderPDFSuccess(FileData) {
  return {
    type: FETCH_PO_PDF_SUCCESS,
    payload: FileData,
  };
}

function fetchPurchaseReturnPDFSuccess(fileData) {
  return {
    type: FETCH_PURCHASE_RETURN_PDF_SUCCESS,
    payload: fileData,
  };
}

export function printPurchaseOrderNoSubtotals(purchaseOrderID) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PO_NOSUBTOTAL_PDF });
    return axios.get(
      `${PURCHASE_ORDER_PRINT_NOSUBTOTAL_URL}` + purchaseOrderID,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      }
    )
    .then((response) => {
      dispatch(printPurchaseOrderNoSubtotalsSuccess(response));
    }, (err) => {
      console.log('Print Error', err);
    });
  };
}

export function printPurchaseOrderNoSubtotalsSuccess(fileData) {
  return {
    type: REQUEST_PO_NOSUBTOTAL_PDF_SUCCESS,
    payload: fileData,
  };
}

export function printPurchaseReturn(purchaseReturnID) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PURCHASE_RETURN_PDF });
    return axios({
      method: 'get',
      url: `${PURCHASE_RETURNS_URL}print/${purchaseReturnID}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
    }).then((response) => {
      dispatch(fetchPurchaseReturnPDFSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      alert(JSON.stringify(err.data));
    });
  };
}

function fetchPurchaseReferencePDFSuccess(fileData) {
  return {
    type: FETCH_PURCHASE_REFERENCE_PDF_SUCCESS,
    payload: fileData,
  };
}

export function printPurchaseReference({ typeradio, group, category, endTime }) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PURCHASE_REFERENCE_PDF });
    return axios({
      method: 'get',
      url: `${PURCHASE_URL}referenceguide/print/${typeradio}/`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
      params: {
        ProductGroup_id: group,
        ProductCategory1_id: category,
        end_time: endTime,
      },
    }).then((response) => {
      dispatch(fetchPurchaseReferencePDFSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      alert(JSON.stringify(err.data));
    });
  };
}

export function printPickup(purchaseOrderID) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PO_PDF });
    return axios.get(
      `${PURCHASE_ORDER_PRINT_URL}pickupprint/${purchaseOrderID}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchPrintPickupSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

function fetchPrintPickupSuccess(FileData) {
  return {
    type: FETCH_PO_PDF_SUCCESS,
    payload: FileData,
  };
}

export function printSalesInvoice(salesInvoiceID) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SI_PDF });
    return axios.get(
      SALES_INVOICE_PRINT_URL + salesInvoiceID,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchSalesInvoicePdfSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
        dispatch(fetchSalesInvoicesPdfFailure(err));
      });
  };
}

export function printSalesInvoiceReturn(salesInvoiceReturnID) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SI_RETURN_PDF });
    return axios.get(
      SALES_INVOICE_RETURN_PRINT_URL + salesInvoiceReturnID,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        console.log(response);
        dispatch(fetchSalesInvoiceReturnPdfSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
        dispatch(fetchSalesInvoicesReturnPdfFailure(err));
      });
  };
}

export function printSalesInvoiceNoSubtotals(salesInvoiceId) {
  return (dispatch) => {
    dispatch({type: REQUEST_SI_NOSUBTOTAL_PDF});
    return axios.get(
      SALES_INVOICE_PRINT_NOSUBTOTAL_URL + salesInvoiceId,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      }
    )
    .then((response) => {
      dispatch(printSalesInvoiceNoSubtotalsSuccess(response))
    }, (err) => {
      console.log('Print Error', err);
    });
  };
}

export function printSalesInvoiceNoSubtotalsSuccess(fileData) {
  return {
    type: REQUEST_SI_NOSUBTOTAL_PDF_SUCCESS,
    payload: fileData,
  };
}

export function printSalesInvoiceReturnsNoSubtotals(salesInvoiceId) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SI_RETURN_NOSUBTOTAL_PDF });
    return axios.get(
      SALES_INVOICE_RETURN_PRINT_NOSUBTOTAL_URL + salesInvoiceId,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      }
    )
    .then((response) => {
      dispatch(printSalesInvoiceReturnNoSubtotalsSuccess(response))
    }, (err) => {
      console.log('Print Error', err);
    });
  };
}

export function printSalesInvoiceReturnNoSubtotalsSuccess(fileData) {
  return {
    type: REQUEST_SI_RETURN_NOSUBTOTAL_PDF_SUCCESS,
    payload: fileData,
  };
}

function fetchSalesInvoicePdfSuccess(FileData) {
  return {
    type: FETCH_SI_PDF_SUCCESS,
    payload: FileData,
  };
}

export function fetchSalesInvoicesPdfFailure(error) {
  return {
    type: FETCH_SI_PDF_FAILURE,
    payload: error,
  };
}

function fetchSalesInvoiceReturnPdfSuccess(FileData) {
  return {
    type: FETCH_SI_RETURN_PDF_SUCCESS,
    payload: FileData,
  };
}

export function fetchSalesInvoicesReturnPdfFailure(error) {
  return {
    type: FETCH_SI_RETURN_PDF_FAILURE,
    payload: error,
  };
}

export function printWarehouseReceive(warehouseReceiveNum) {
  return (dispatch) => {
    dispatch({ type: REQUEST_WR_PDF });
    return axios.get(
      WAREHOUSE_RECEIVE_PRINT_URL + warehouseReceiveNum,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchWarehouseReceiveSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

export const fetchLineLabel = (WarehouseReceive_id, WarehouseReceiveLine_id) => dispatch => {
  dispatch({ type: REQUEST_WR_PDF });
  axios.get(
    `${RECEIVE_URL}print_label/${WarehouseReceive_id}/${WarehouseReceiveLine_id}`,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
    },
  )
    .then((response) => {
      dispatch(fetchWarehouseReceiveSuccess(response));
    }, (err) => {
      console.log('ERROR IN response', err);
    });
}

function fetchWarehouseReceiveSuccess(FileData) {
  return {
    type: FETCH_WR_PDF_SUCCESS,
    payload: FileData,
  };
}

/*
  makes a get request for an AR report and signals for success and failure
  params:
    customerId: number,
    fromDate: string string in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ),
    toDate: string string in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ),
    cutoffDate: string string in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ),
    isSimplified: boolean
  returns:
    function for thunk middleware
*/


function fetchARReportSuccess(fileData) {
  return {
    type: FETCH_AR_PDF_SUCCESS,
    payload: fileData,
  };
}

export const printSalesInvoiceForCustomerStatement = invoiceId => (dispatch) => {
  dispatch({ type: REQUEST_AR_PDF });
  return axios({
    method: 'get',
    url: `${SALES_INVOICE_PRINT_URL}${invoiceId}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    responseType: 'blob',
  })
    .then((response) => {
      dispatch(fetchARReportSuccess(response));
    }, () => {
      alert(JSON.stringify(DEFAULT_ERROR));
    });
}

export function printARReport(customerId, fromDate, toDate, cutoffDate, isSimplified) {
  const mode = isSimplified ? 'simplifiedprint' : 'print';
  return (dispatch) => {
    dispatch({ type: REQUEST_AR_PDF });
    return axios({
      method: 'get',
      url: `${AR_PRINT_URL}${customerId}/${mode}/`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
      params: {
        start_date: fromDate,
        end_date: toDate,
        cut_off_date: cutoffDate,
      },
    }).then((response) => {
      dispatch(fetchARReportSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      } else if (err.status === 400) {
        err.data = 'No Invoices in this Date Range';
      }
      alert(JSON.stringify(err.data));
    });
  };
}


export function printPlainARReport(customerId, fromDate, toDate, cutoffDate, mode) {
  return (dispatch) => {
    dispatch({ type: REQUEST_AR_PDF });
    return axios({
      method: 'get',
      url: `${AR_PRINT_PLAIN_URL}${customerId}/${mode}/`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
      params: {
        start_date: fromDate,
        end_date: toDate,
      },
    }).then((response) => {
      dispatch(fetchARReportSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      } else if (err.status === 400) {
        err.data = 'No Invoices in this Date Range';
      }
      alert(JSON.stringify(err.data));
    });
  };
}


function fetchAPReportSuccess(fileData) {
  return {
    type: FETCH_AP_PDF_SUCCESS,
    payload: fileData,
  };
}

/*
  makes a get request for an AP report and signals for success and failure
  params:
    vendorrId: number,
    fromDate: string in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ),
    toDate: string string in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ),
    cutoffDate: string in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ),
    isSimplified: boolean
  returns:
    function for thunk middleware
*/
export function printAPReport(vendorId, fromDate, toDate, paymentCutoffDate, isSimplified) {
  const type = isSimplified ? 'simplifiedprint' : 'print';
  const url = `${AP_PRINT_URL}${vendorId}/${type}/`;
  return (dispatch) => {
    dispatch({ type: REQUEST_AP_PDF });
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
      params: {
        start_date: fromDate,
        end_date: toDate,
        cut_off_date: paymentCutoffDate,
      },
    }).then((response) => {
      dispatch(fetchAPReportSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      } else if (err.status === 400) {
        err.data = 'No Invoices in this Date Range';
      }
      alert(JSON.stringify(err.data));
    });
  };
}

function fetchRoutesPdfSuccess(fileData) {
  return {
    type: REQUEST_ROUTING_PDF_SUCCESS,
    payload: fileData,
  };
}

function fetchRoutesPdfFailure(error) {
  return {
    type: REQUEST_ROUTING_PDF_FAILURE,
    payload: error,
  };
}

export function printDispatchRoute(routeId, date) {
  const { fromDate, toDate } = getFromToDates(date);
  const url = `${DISPATCH_URL}route/${routeId}/print?start_time=${fromDate}&end_time=${toDate}`;
  return (dispatch) => {
    dispatch({ type: REQUEST_ROUTING_PDF });
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
    }).then((response) => {
      dispatch(fetchRoutesPdfSuccess(response));
    }, (err) => {
      dispatch(fetchRoutesPdfFailure(err));
    });
  };
}

function fetchDispatchPickingListPdfSuccess(fileData) {
  return {
    type: REQUEST_DISPATCH_PICKING_LIST_PDF_SUCCESS,
    payload: fileData,
  };
}

function fetchDispatchPickingListPdfFailure(error) {
  return {
    type: REQUEST_DISPATCH_PICKING_LIST_PDF_FAILURE,
    payload: error,
  };
}

export function printDispatchPickingList(routeId, date) {
  const { fromDate, toDate } = getFromToDates(date);
  const url = `${DISPATCH_URL}route/${routeId}/print_picking_list?start_time=${fromDate}&end_time=${toDate}`;
  return (dispatch) => {
    dispatch({ type: REQUEST_DISPATCH_PICKING_LIST_PDF });
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
    }).then((response) => {
      dispatch(fetchDispatchPickingListPdfSuccess(response));
    }, (err) => {
      dispatch(fetchDispatchPickingListPdfFailure(err));
    });
  };
}

function fetchDispatchPackingListPdfSuccess(fileData) {
  return {
    type: REQUEST_DISPATCH_PACKING_LIST_PDF_SUCCESS,
    payload: fileData,
  };
}

function fetchDispatchPackingListPdfFailure(error) {
  return {
    type: REQUEST_DISPATCH_PACKING_LIST_PDF_FAILURE,
    payload: error,
  };
}

export function printDispatchPackingList(routeId, date) {
  const { fromDate, toDate } = getFromToDates(date);
  const url = `${DISPATCH_URL}print_packing_list/${routeId}?start_time=${fromDate}&end_time=${toDate}`;
  return (dispatch) => {
    dispatch({ type: REQUEST_DISPATCH_PACKING_LIST_PDF });
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
    }).then((response) => {
      dispatch(fetchDispatchPackingListPdfSuccess(response));
    }, (err) => {
      dispatch(fetchDispatchPackingListPdfFailure(err));
    });
  };
}

function fetchDispatchSalesInvoicePdfSuccess(fileData) {
  return {
    type: REQUEST_DISPATCH_SALES_INVOICE_PDF_SUCCESS,
    payload: fileData,
  };
}

function fetchDispatchSalesInvoicePdfFailure(error) {
  return {
    type: REQUEST_DISPATCH_SALES_INVOICE_PDF_FAILURE,
    payload: error,
  };
}

export function printDispatchSalesInvoice(routeId, date) {
  const { fromDate, toDate } = getFromToDates(date);
  const url = `${DISPATCH_URL}route/${routeId}/print_sales_invoice?start_time=${fromDate}&end_time=${toDate}`;
  return (dispatch) => {
    dispatch({ type: REQUEST_DISPATCH_SALES_INVOICE_PDF });
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
    }).then((response) => {
      dispatch(fetchDispatchSalesInvoicePdfSuccess(response));
    }, (err) => {
      dispatch(fetchDispatchSalesInvoicePdfFailure(err));
    });
  };
}

export function printPurchaseReturnNoSubtotals(returnId) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL });
    return axios.get(
      PURCHASE_RETURNS_NO_SUBTOTALS + returnId,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      }
    )
    .then((response) => {
      dispatch(printPurchaseReturnNoSubtotalsSuccess(response));
    }, (err) => {
      console.log('Purchase Return Error', err);
    });
  };
}

export function printPurchaseReturnNoSubtotalsSuccess(fileData) {
  return {
    type: REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL_SUCCESS,
    payload: fileData,
  }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/print_actions.js